import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import axios from "axios";
import { toast } from "react-toastify";
import { Link, useNavigate } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";

function Login() {
  const navigate = useNavigate();

  // Theme colors
  const accentColor = "rgb(219, 68, 55)";
  const backgroundColor = "#ffffff";
  const textColor = "#000000";
  const textSecondary = "#666666";
  const borderColor = "#e0e0e0";

  const [LoginNumber, setLoginNumber] = useState("");
  const [hide_show, setHide_show] = useState(1);
  const [OTP, setOTP] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  let server_url = localStorage.getItem("server_url");
  const login_url = localStorage.getItem("login_url")
    ? localStorage.getItem("login_url")
    : "/";

  if (login_url.includes("null")) {
    login_url = "/";
  }

  function generateRandomString(length = 10) {
    const chars =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let result = "";
    for (let i = 0; i < length; i++) {
      result += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return result;
  }

  const randomCode = generateRandomString();
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  const getDeviceId = () => {
    let deviceId = localStorage.getItem("dealer_device_id");
    if (!deviceId) {
      deviceId = uuidv4();
      localStorage.setItem("dealer_device_id", deviceId);
    }
    return deviceId;
  };

  const dealer_device_id = getDeviceId();

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    if (localStorage.getItem("LoginNumber")) {
      navigate("/");
    }
  }, [navigate]);

  async function SendOTP() {
    if (!LoginNumber || LoginNumber.length !== 10) {
      return toast("Please enter a valid 10-digit mobile number");
    }

    setIsLoading(true);

    const formData = new FormData();
    formData.append("company_id", "2");
    formData.append("dealer_mobile", LoginNumber);
    formData.append("dealer_android_token", "");
    formData.append("dealer_ios_token", "");

    try {
      const res = await axios.post(`${server_url}dealer_login.php`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (res.data.status === "0") {
        toast(res.data.error);
      } else if (res.data.status === "1") {
        toast(res.data.result.error || "OTP sent successfully!");
        setHide_show(2);
      } else {
        toast("Please contact admin.");
      }
    } catch (e) {
      toast("Please Try After Some Time.");
    } finally {
      setIsLoading(false);
    }
  }

  async function SubmitOTP() {
    if (!LoginNumber) return toast("Mobile number missing");
    if (!OTP || OTP.length !== 4) return toast("Please enter 4-digit OTP");

    setIsLoading(true);

    const formData = new FormData();
    formData.append("company_id", "2");
    formData.append("dealer_mobile", LoginNumber);
    formData.append("dealer_otp", OTP);
    formData.append(
      "dealer_device_id",
      dealer_device_id ? dealer_device_id : randomCode
    );
    formData.append("dealer_android_token", "");
    formData.append("dealer_ios_token", "");
    formData.append("dealer_device_name", "Web");

    try {
      const result = await axios.post(
        `${server_url}dealer_login_otp_verify.php`,
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );

      if (result.data.status == "0") {
        toast(result.data.error);
      } else if (result.data.status == "1" || result.data.status == "4") {
        const dealerInfo = result.data.result[0];
        localStorage.setItem(
          "token",
          dealer_device_id ? dealer_device_id : randomCode
        );
        localStorage.setItem(
          "notificaion_count",
          dealerInfo.dealer_notification_count
        );
        localStorage.setItem("LoginNumber", LoginNumber);
        localStorage.setItem("app_cache_clear", dealerInfo.app_cache_clear);
        localStorage.setItem("dealer_price_set", dealerInfo.dealer_price_set);
        localStorage.setItem(
          "dealer_price_set_new",
          dealerInfo.dealer_price_set_new
        );

        localStorage.setItem("dealer_id", dealerInfo.dealer_id);
        localStorage.setItem("dealer_firm_name", dealerInfo.dealer_firm_name);
        localStorage.setItem(
          "dealer_order_varification_mobile",
          dealerInfo.dealer_order_varification_mobile
        );
        localStorage.setItem(
          "dealer_login_mobile",
          dealerInfo.dealer_login_mobile
        );
        localStorage.setItem("dealer_email", dealerInfo.dealer_email);
        localStorage.setItem("dealer_address", dealerInfo.dealer_address);
        localStorage.setItem("dealer_pincode", dealerInfo.dealer_pincode);
        localStorage.setItem("dealer_pan_number", dealerInfo.dealer_pan_number);
        localStorage.setItem("dealer_gst_number", dealerInfo.dealer_gst_number);
        localStorage.setItem("city_name", dealerInfo.city_name);

        check_user(
          dealerInfo.dealer_id,
          dealer_device_id ? dealer_device_id : randomCode
        );
      } else {
        toast("Please contact admin.");
      }
    } catch (e) {
      toast("Please Try After Some Time.");
    } finally {
      setIsLoading(false);
    }
  }

  function check_user(dealer_id, token) {
    const formData = new FormData();
    formData.append("company_id", "2");
    formData.append("dealer_id", dealer_id);
    formData.append("dealer_android_token", "");
    formData.append("dealer_ios_token", "");
    formData.append("device_token", token);
    axios
      .post(`${server_url}check_dealer.php`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res1) => {
        if (res1.data.status === "1") {
          const d = res1.data.result[0];
          localStorage.setItem("local_overdue_amount", d.overdue_amount);
          localStorage.setItem("local_dealer_os", d.dealer_os);
          localStorage.setItem("order_date", d.order_date);
          localStorage.setItem("local_items_in_cart", d.items_in_cart);
          localStorage.setItem(
            "local_current_order_status",
            d.current_order_status
          );
          localStorage.setItem(
            "local_order_final_total_with_gst",
            d.order_final_total_with_gst
          );
          localStorage.setItem("local_order_id", d.order_id);
          localStorage.setItem("admin_message", d.admin_message);
          localStorage.setItem("local_dealer_firm_name", d.dealer_firm_name);

          navigate(login_url);
        }
      });
  }

  return (
    <>
      <div className="login-container">
        {/* Login Card */}
        <div className="login-card">
          <div className="logo-section">
            <div className="logo-circle">
              <i className="fa fa-user-lock"></i>
            </div>
            <h2>Welcome Back</h2>
            <p>Sign in to continue</p>
          </div>

          <form onSubmit={(e) => e.preventDefault()} className="login-form">
            {/* Mobile Number */}
            <div className="input-group">
              <div className="input-wrapper">
                <i className="fa fa-phone input-icon"></i>
                <input
                  type="text"
                  inputMode="numeric"
                  value={LoginNumber}
                  onChange={(e) => {
                    const val = e.target.value.replace(/\D/g, "").slice(0, 10);
                    setLoginNumber(val);
                  }}
                  placeholder=" "
                  readOnly={hide_show === 2}
                  className="input-field"
                  id="mobile"
                />
                <label htmlFor="mobile" className="input-label">
                  Mobile Number
                </label>
              </div>
              {LoginNumber.length > 0 && LoginNumber.length !== 10 && (
                <small className="error-text">Enter 10 digits </small>
              )}
            </div>

            {/* OTP Field */}
            {hide_show === 2 && (
              <div className="input-group">
                <div className="input-wrapper">
                  <i className="fa fa-shield-alt input-icon"></i>
                  <input
                    type="text"
                    inputMode="numeric"
                    value={OTP}
                    onChange={(e) => {
                      const val = e.target.value.replace(/\D/g, "").slice(0, 4);
                      setOTP(val);
                    }}
                    placeholder=" "
                    className="input-field"
                    id="otp"
                    maxLength={4}
                  />
                  <label htmlFor="otp" className="input-label">
                    Enter OTP
                  </label>
                </div>
                {OTP.length > 0 && OTP.length !== 4 && (
                  <small className="error-text">Enter 4-digit OTP</small>
                )}
              </div>
            )}

            {/* Submit Button */}
            <button
              onClick={hide_show === 2 ? SubmitOTP : SendOTP}
              className="submit-btn"
              disabled={
                isLoading ||
                (hide_show === 1 &&
                  (LoginNumber.length !== 10 || !LoginNumber)) ||
                (hide_show === 2 && OTP.length !== 4)
              }
            >
              {isLoading ? (
                <>
                  <span>{hide_show === 2 ? "Verifying..." : "Sending..."}</span>
                  <i className="fa fa-spinner fa-spin"></i>
                </>
              ) : (
                <>
                  <span>{hide_show === 2 ? "Verify OTP" : "Send OTP"}</span>
                  <i
                    className={`fa ${
                      hide_show === 2 ? "fa-arrow-right" : "fa-paper-plane"
                    }`}
                  ></i>
                </>
              )}
            </button>
          </form>

          <div className="footer-text">
            <p>
              By continuing, you agree to our{" "}
              <span className="link">Terms</span> &{" "}
              <span className="link">Privacy Policy</span>
            </p>
            <div className="footer-links">
              <Link to="/registration">
                <p>Registration Now</p>
              </Link>
              <Link to="/">
                <p>Skip Login</p>
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* Custom CSS */}
      <style jsx>{`
        .login-container {
          position: relative;
          min-height: 100vh;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 20px;
          overflow: hidden;
          font-family: "Segoe UI", sans-serif;
          background: ${backgroundColor};
        }

        .login-card {
          position: relative;
          z-index: 3;
          width: 100%;
          max-width: 380px;
          background: #f4f1f1;
          border-radius: 20px;
          padding: 32px 28px;
          box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
          border: 1px solid ${borderColor};
          animation: slideUp 0.6s ease-out;
        }

        @keyframes slideUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .logo-section {
          text-align: center;
          margin-bottom: 28px;
        }

        .logo-circle {
          width: 70px;
          height: 70px;
          background: ${accentColor};
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto 16px;
          color: white;
          font-size: 28px;
          box-shadow: 0 4px 15px rgba(219, 68, 55, 0.3);
        }

        .logo-section h2 {
          font-size: 24px;
          font-weight: 700;
          color: ${textColor};
          margin: 0 0 6px;
        }

        .logo-section p {
          color: ${textSecondary};
          font-size: 14px;
          margin: 0;
        }

        .login-form {
          display: flex;
          flex-direction: column;
          gap: 16px;
        }

        .input-group {
          position: relative;
        }

        .input-wrapper {
          position: relative;
          width: 100%;
        }

        .input-icon {
          position: absolute;
          left: 14px;
          top: 50%;
          transform: translateY(-50%);
          color: ${textSecondary};
          font-size: 18px;
          z-index: 2;
          transition: color 0.3s;
        }

        .input-field {
          width: 100%;
          padding: 16px 16px 16px 48px;
          font-size: 16px;
          background: ${backgroundColor};
          border: 1px solid ${borderColor};
          border-radius: 12px;
          color: ${textColor};
          transition: all 0.3s ease;
          outline: none;
        }

        .input-field::placeholder {
          color: transparent;
        }

        .input-field:focus {
          background: ${backgroundColor};
          border-color: ${accentColor};
          box-shadow: 0 0 0 3px rgba(219, 68, 55, 0.2);
        }

        .input-field:focus + .input-label,
        .input-field:not(:placeholder-shown) + .input-label {
          top: -8px;
          left: 12px;
          font-size: 12px;
          border-radius: 10px;
          background-color: ${accentColor};
          color: #ffffff;
          padding: 0 6px;
        }

        .input-label {
          position: absolute;
          left: 48px;
          top: 50%;
          transform: translateY(-50%);
          font-size: 15px;
          color: ${textSecondary};
          pointer-events: none;
          transition: all 0.3s ease;
          background: transparent;
        }

        .error-text {
          color: ${accentColor};
          font-size: 12px;
          margin-top: 4px;
          padding-left: 48px;
          display: block;
        }

        .submit-btn {
          margin-top: 12px;
          padding: 14px;
          font-size: 16px;
          font-weight: 600;
          color: white;
          background: ${accentColor};
          border: none;
          border-radius: 12px;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 10px;
          transition: all 0.3s ease;
          box-shadow: 0 4px 15px rgba(219, 68, 55, 0.3);
        }

        .submit-btn:hover:not(:disabled) {
          transform: translateY(-2px);
          box-shadow: 0 8px 20px rgba(219, 68, 55, 0.4);
          background: #d63224;
        }

        .submit-btn:active {
          transform: translateY(0);
        }

        .submit-btn:disabled {
          opacity: 0.6;
          cursor: not-allowed;
          transform: none;
        }

        .submit-btn i {
          font-size: 18px;
          transition: transform 0.3s;
        }

        .submit-btn:hover i {
          transform: translateX(4px);
        }

        .footer-text {
          text-align: center;
          margin-top: 20px;
        }

        .footer-text p {
          color: ${textSecondary};
          margin: 0 0 15px 0;
        }

        .link {
          color: ${accentColor};
          font-weight: 500;
          text-decoration: underline;
          cursor: pointer;
        }

        .link:hover {
          color: #d63224;
        }

        .footer-links {
          display: flex;
          justify-content: space-between;
          margin-top: 15px;
          padding-top: 15px;
          border-top: 1px solid ${borderColor};
        }

        .footer-links a {
          text-decoration: none;
          color: ${accentColor};
          font-weight: 500;
          transition: color 0.3s ease;
        }

        .footer-links a:hover {
          color: #d63224;
        }

        .footer-links p {
          margin: 0;
          font-size: 14px;
        }

        /* Mobile Adjustments */
        @media (max-width: 480px) {
          .login-card {
            padding: 24px 20px;
            max-width: 340px;
          }
          .logo-circle {
            width: 60px;
            height: 60px;
            font-size: 24px;
          }
          .logo-section h2 {
            font-size: 22px;
          }
          .input-field {
            padding: 14px 14px 14px 44px;
            font-size: 15px;
          }
          .submit-btn {
            padding: 13px;
            font-size: 15px;
          }
          .footer-links {
            flex-direction: column;
            gap: 10px;
            text-align: center;
          }
        }
      `}</style>
    </>
  );
}

export default Login;